import clsx, { type ClassValue } from 'clsx';

// Re-export as `cn` so Tailwind class conditionals stay compact at call sites.
// (clsx handles undefined / false / nested arrays.)
export function cn(...args: ClassValue[]): string {
  return clsx(args);
}
